export default __webpack_public_path__ + "static/media/avatar-laurinha.91fd50c9.webp";